import React from 'react';
import { Archive, Calendar } from 'lucide-react';
import Navigation from './Navigation';
import Footer from './Footer';
import CheerJamboreeFlyer from './jamboree/CheerJamboreeFlyer';
import PanthersClassicFlyer from './jamboree/PanthersClassicFlyer';

const HERO_STYLE = {
  padding: '4rem 1rem 2rem',
  textAlign: 'center',
  background: 'linear-gradient(180deg, #000 0%, #0a0a0a 100%)',
  borderBottom: '1px solid rgba(255, 215, 0, 0.2)',
};

const PILL_STYLE = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.4rem',
  background: 'rgba(255, 215, 0, 0.12)',
  color: '#FFD700',
  border: '1px solid rgba(255, 215, 0, 0.4)',
  padding: '0.4rem 1rem',
  borderRadius: '999px',
  fontSize: '0.78rem',
  letterSpacing: '2px',
  fontWeight: 800,
  marginBottom: '1rem',
};

const RIBBON_STYLE = {
  position: 'absolute',
  top: '18px',
  left: '-40px',
  background: 'linear-gradient(90deg, #FFD700 0%, #FFC500 100%)',
  color: '#000',
  padding: '0.35rem 3rem',
  fontSize: '0.72rem',
  fontWeight: 900,
  letterSpacing: '2px',
  transform: 'rotate(-30deg)',
  boxShadow: '0 6px 18px rgba(255, 215, 0, 0.4)',
  zIndex: 10,
};

const SECTION_STYLE = {
  padding: '3rem 1rem',
  background: 'linear-gradient(180deg, #050505 0%, #0d0a00 100%)',
  borderTop: '1px solid rgba(255, 215, 0, 0.15)',
  position: 'relative',
};

const SectionHeader = ({ badge, title, subtitle }) => (
  <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
    <span
      style={{
        display: 'inline-block',
        background: '#FFD700',
        color: '#000',
        padding: '0.35rem 0.95rem',
        borderRadius: '999px',
        fontWeight: 800,
        fontSize: '0.78rem',
        letterSpacing: '1px',
        marginBottom: '0.75rem',
      }}
    >
      {badge}
    </span>
    <h2 style={{ color: '#FFD700', fontSize: 'clamp(1.6rem, 3vw, 2.25rem)', margin: '0 0 0.5rem 0', fontWeight: 800 }}>
      {title}
    </h2>
    {subtitle && (
      <p style={{ color: '#d4d4d4', maxWidth: '640px', margin: '0 auto', lineHeight: 1.6 }}>
        {subtitle}
      </p>
    )}
  </div>
);

const PastEventsPage = () => (
  <div className="page-container" data-testid="past-events-page">
    <Navigation />

    <main className="main-content">
      {/* Hero */}
      <section style={HERO_STYLE}>
        <div className="container">
          <span style={PILL_STYLE}>
            <Archive size={14} /> ARCHIVE
          </span>
          <h1 style={{ color: '#fff', fontSize: 'clamp(2rem, 5vw, 3.25rem)', margin: 0, fontWeight: 900 }}>
            Past Events
          </h1>
          <p style={{ color: '#d4d4d4', maxWidth: '640px', margin: '1rem auto 0', lineHeight: 1.6 }}>
            A look back at the Panthers Classic Jamboree and Cheer Jamboree from the 2026 season.
            Flyers and details preserved here for reference.
          </p>
        </div>
      </section>

      {/* Panthers Classic (Past) */}
      <section style={SECTION_STYLE} data-testid="past-event-football">
        <div style={RIBBON_STYLE}>PAST EVENT · 2026</div>
        <SectionHeader
          badge="🏈 AUGUST 8, 2026"
          title="Panthers Classic Jamboree"
          subtitle="Football & Flag showcase held at Randallstown High School."
        />
        <PanthersClassicFlyer />
      </section>

      {/* Cheer Jamboree (Past) */}
      <section style={SECTION_STYLE} data-testid="past-event-cheer">
        <div style={RIBBON_STYLE}>PAST EVENT · 2026</div>
        <SectionHeader
          badge="✨ AUGUST 8, 2026"
          title="Cheer Jamboree"
          subtitle="A 5-event cheerleading showcase for squads across the region."
        />
        <CheerJamboreeFlyer />
      </section>

      {/* Callout */}
      <section
        style={{
          padding: '3rem 1rem',
          textAlign: 'center',
          background: '#0a0a0a',
          borderTop: '1px solid rgba(255, 215, 0, 0.2)',
        }}
      >
        <Calendar size={40} style={{ color: '#FFD700', marginBottom: '0.75rem' }} />
        <h3 style={{ color: '#fff', margin: '0 0 0.5rem 0' }}>Stay tuned for our next event</h3>
        <p style={{ color: '#a0a0a0', maxWidth: '520px', margin: '0 auto' }}>
          The Panthers Classic returns each summer. Follow us on social or join a practice to hear about the 2027 season first.
        </p>
      </section>
    </main>

    <Footer />
  </div>
);

export default PastEventsPage;
